import React, { useState } from 'react';
import logo from '../images/logo.jpeg';

const Footer = () => {
  const [currentYear] = useState(new Date().getFullYear());

  const footerLinks = [
    {
      title: 'Platform',
      links: [
        { name: 'Features', href: '#features' },
        { name: 'Pricing', href: '#pricing' },
        { name: 'Download', href: '#download' },
        { name: 'API', href: '#' }
      ]
    },
    {
      title: 'Company',
      links: [
        { name: 'About', href: '#about' },
        { name: 'Blog', href: '#' },
        { name: 'Careers', href: '#' },
        { name: 'Contact', href: '#contact' }
      ]
    },
    {
      title: 'Legal',
      links: [
        { name: 'Privacy', href: '#' },
        { name: 'Terms', href: '#' },
        { name: 'Security', href: '#' },
        { name: 'Cookies', href: '#' }
      ]
    }
  ];

  const socialLinks = [
    { name: 'Twitter', href: '#', icon: '🐦' },
    { name: 'Instagram', href: '#', icon: '📷' },
    { name: 'Discord', href: '#', icon: '🎮' },
    { name: 'YouTube', href: '#', icon: '🎬' }
  ];

  return (
    <footer className="bg-gradient-to-br from-fuchsia-900 via-pink-800 to-orange-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-r from-yellow-400 to-pink-500 rounded-xl flex items-center justify-center">
                <img
                  src={logo}
                  alt="MASTIVIBES"
                  className="w-8 h-8 object-contain"
                />
              </div>
              <span className="text-2xl font-bold text-white">MASTIVIBES</span>
            </div>
            <p className="text-white/70 text-sm mb-6">
              Connect, create, and celebrate with the ultimate social platform.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-200"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Links Columns */}
          {footerLinks.map((section, index) => (
            <div key={index} className="space-y-4">
              <h4 className="text-white font-bold text-lg">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link.href}
                      className="text-white/70 hover:text-white transition-colors duration-200 text-sm"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 my-8"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {/* Copyright */}
          <div className="text-white/60 text-sm">
            © {currentYear} MASTIVIBES. All rights reserved.
          </div>

          {/* App Stores */}
          <div className="flex space-x-3">
            <button className="flex items-center space-x-2 bg-black/80 text-white px-4 py-2 rounded-lg hover:bg-black/90 transition-colors duration-200 text-sm">
              <span>📱</span>
              <span>App Store</span>
            </button>
            <button className="flex items-center space-x-2 bg-green-700 text-white px-4 py-2 rounded-lg hover:bg-green-800 transition-colors duration-200 text-sm">
              <span>🤖</span>
              <span>Google Play</span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;